import type { UseQueryResult } from '@tanstack/react-query';

import type { TreeSpecies } from '../../../api/tree-species';

import TreeSpeciesRow, { type TreeSpeciesRowActions } from './TreeSpeciesRow';

interface Props {
  list: UseQueryResult<TreeSpecies[], Error>;
  actions: TreeSpeciesRowActions;
}

const notice = 'py-8 text-center text-sm';

export default function TreeSpeciesList({ list, actions }: Props) {
  if (list.isLoading) {
    return <div className={`${notice} text-stone-500 dark:text-stone-400`}>Loading...</div>;
  }
  if (list.isError) {
    return (
      <div role="alert" className={`${notice} text-red-500`}>
        {list.error.message}
      </div>
    );
  }

  const species = list.data ?? [];
  return (
    <ul className="divide-y divide-stone-100 dark:divide-stone-700/50">
      {species.map((sp) => (
        <TreeSpeciesRow key={sp.id} species={sp} actions={actions} />
      ))}
      {species.length === 0 && (
        <li className="py-6 text-center text-stone-500 dark:text-stone-400 text-sm">
          No tree species configured
        </li>
      )}
    </ul>
  );
}
